// Invoices and reports as PDFs the server renders and keeps (#621): the
// words a button says, what a failed request for one says, and the name the
// file goes under. The rules are `core/src/document_pdf.rs`, which both
// phones ask too, so the three read the same.

import { coreSync } from './core.js';

/** The two kinds of document the server renders. */
export const DOCUMENT_KINDS = Object.freeze({ invoice: 'invoice', report: 'report' });

/** A button's word or a sentence by code (`open_pdf`, `offline`, …). */
export function documentPdfWord(code) {
  return coreSync().documentPdfMessage(String(code)) ?? String(code);
}

/**
 * What a failed `documentLink` call says: from the callable's error code as
 * the web SDK spells it (`functions/unavailable`), and its message, which the
 * function writes for a teacher. `offline` when the browser knew first.
 */
export function documentLinkErrorMessage(code, said = null) {
  return coreSync().documentLinkErrorMessage(String(code ?? ''), said == null ? null : String(said));
}

/**
 * The name the PDF is saved or shared as: `Invoice 12 – Smith Family.pdf`,
 * or a report's CSV name with `.pdf`.
 */
export function documentFilename({
  kind, title = null, number = null, party = null, date = null,
}) {
  const n = Number.isFinite(Number(number)) && number !== null && number !== '' ? Number(number) : null;
  return coreSync().documentFilename(
    String(kind),
    title == null ? null : String(title),
    n,
    party == null ? null : String(party),
    date == null ? null : String(date),
  );
}

export const isDocumentKind = (kind) => typeof kind === 'string' && coreSync().isDocumentKind(kind);
